<div>
  <HomeNavBar />

  <div class="container py-4 py-lg-5 pb-extra mb-5">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-11">
        <div
          class="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-4"
        >
          <div class="d-flex align-items-center gap-3">
            <button
              class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
              @click="go_back"
            >
              <i class="bi bi-chevron-left"></i>
            </button>
            <div>
              <h1 class="text-dark mb-1 fw-bold marketplace-toolbar-title">
                My Subscription
              </h1>
            </div>
          </div>
        </div>

        <div
          v-if="payment_history_loading"
          class="d-flex flex-column align-items-center justify-content-center text-center checkout-summary-panel"
        >
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p class="text-xs text-muted mb-0">Loading membership details...</p>
        </div>

        <div v-else-if="has_current_membership">
          <div
            class="card card-hover mb-4 d-flex flex-column border-bottom rounded border-0 full-width-mobile"
          >
            <div class="card-body">
              <div class="row g-4 align-items-start">
                <div class="col-lg-9">
                  <div class="text-uppercase fw-bold text-primary text-xxs mb-2">
                    Current plan
                  </div>

                  <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                    <h2 class="mb-0 fw-bold text-dark">
                      {{ current_membership?.membership_type?.name }}
                    </h2>
                    <span
                      class="badge rounded px-3 py-2 text-xxs fw-semibold"
                      :class="is_active ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'"
                    >
                      <i
                        v-if="is_active"
                        class="bi bi-circle-fill me-1 text-xxxs"
                      ></i>
                      {{ is_active ? 'active' : 'inactive'}}
                    </span>
                  </div>

                  <p v-if="current_membership?.description" class="text-muted mb-0">
                    {{(this.current_membership?.description || '').slice(0, 60)}}
                  </p>
                </div>
              </div>

              <hr class="my-4" />

              <div class="row g-3 align-items-stretch">
                <div class="col-md-8">
                  <div
                    class="border rounded h-100 d-flex align-items-center gap-3 manage-membership-card-panel p-1"
                  >
                    <div
                      class="d-inline-flex align-items-center justify-content-center rounded bg-white shadow-sm flex-shrink-0 profile-avatar-small"
                    >
                      <i class="bi bi-calendar-check text-primary"></i>
                    </div>

                    <div class="min-w-0">
                      <div
                        class="text-uppercase fw-bold text-primary text-xxs mb-1"
                      >
                        Billing
                      </div>
                      <div class="fw-bold text-dark">
                        {{ billing_cycle || '--' }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 ps-md-0">
                  <div
                    class="h-100 d-flex flex-row justify-content-start justify-content-md-end align-items-center gap-2 text-start text-md-end ps-1 ps-md-0"
                  >
                    <div class="text-uppercase text-muted text-xxs fw-bold mb-0">
                      Price
                    </div>
                    <div>
                      <span
                        class="badge bg-white text-dark border px-4 py-3"
                      >
                        {{ current_membership?.membership_pricing?.[0]?.price }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row g-4">
            <div class="col-lg-8">
              <div class="border-0 shadow-sm rounded h-100">
                <div class="card-body p-3 p-md-4">
                  <div class="row g-3 mb-4">
                    <div class="col-6">
                      <div class="d-flex align-items-start gap-3">
                        <div
                          class="d-inline-flex align-items-center justify-content-center rounded bg-primary-subtle text-primary flex-shrink-0 profile-avatar-small"
                        >
                          <i class="bi bi-calendar-event"></i>
                        </div>
                        <div>
                          <p class="text-muted text-xs mb-1">Next renewal</p>
                          <p class="fw-bold text-dark mb-0">
                            {{ format_display_date(renewal_date) }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="d-flex align-items-start gap-3">
                        <div
                          class="d-inline-flex align-items-center justify-content-center rounded bg-primary-subtle text-primary flex-shrink-0 profile-avatar-small"
                        >
                          <i class="bi bi-cash-stack"></i>
                        </div>
                        <div>
                          <p class="text-muted text-xs mb-1">Next charge</p>
                          <p class="fw-bold text-dark mb-0">
                            {{ current_membership?.membership_pricing?.[0]?.price}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr class="my-4" />

                  <p class="text-dark mb-3 fw-bold">Included perks this cycle</p>

                  <div class="d-flex flex-column gap-3">
                    <div
                      v-for="perk in current_membership?.membership_perks"
                      :key="perk.id"
                      class="d-flex align-items-start gap-3"
                    >
                      <div
                        class="d-inline-flex align-items-center justify-content-center rounded-circle bg-success-subtle text-success flex-shrink-0 profile-avatar-small"
                      >
                        <i class="bi bi-check-lg"></i>
                      </div>
                      <div class="min-w-0">
                        <h3 class="fw-bold text-dark text-xs mb-1">
                          {{ perk.perk.name }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="border-0 shadow-sm rounded h-100">
                <div class="card-body p-3 p-md-4 d-flex flex-column">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <span
                      class="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary flex-shrink-0"
                      style="width: 28px; height: 28px;"
                    >
                      <i class="bi bi-info-circle-fill small"></i>
                    </span>

                    <h6 class="fw-bold text-dark mb-0">
                      Need to make changes?
                    </h6>
                    
                  </div>
                  <p class="text-muted small mb-0">
                    You can update your plan or cancel anytime.
                  </p>

                  <div class="d-grid gap-3 mt-2">
                    <button
                      class="btn btn-primary d-flex align-items-center justify-content-between rounded py-3 px-3 fw-semibold"
                      @click="navigate_to_plans"
                    >
                      <span>Update Subscription</span>
                      <i class="bi bi-chevron-right"></i>
                    </button>
                    <button
                      class="d-none btn btn-danger d-flex align-items-center justify-content-between rounded py-3 px-3 fw-semibold">
                      <span>Cancel Subscription</span>
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-else
          class="d-flex flex-column align-items-center justify-content-center text-center checkout-summary-panel"
        >
          <i class="bi bi-patch-question fs-2 text-primary mb-3"></i>
          <h2 class="h5 fw-bold text-dark mb-2">No active membership found</h2>
          <p class="text-xs text-muted mb-0">
            We could not find membership details for this user yet.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
